import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App, { preloadPage } from "@/App";

const container = document.getElementById("root");

const render = () =>
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

// A prerendered page (scripts/prerender.js) is already on screen. Load its
// chunk first, so the first render replaces it with the same page, never
// with a blank fallback. createRoot, not hydrateRoot: it renders over the
// markup, so anything that differs from build time (today's date, the live
// status) is never a hydration mismatch.
if (container.hasChildNodes()) preloadPage(window.location.pathname).then(render, render);
else render();
